"use client";

import { useEffect } from "react";
import { CloudOff } from "lucide-react";
import { useOnline } from "@/lib/hooks/use-online";

/**
 * Persistent top bar shown while offline. Sticky so it stays visible above
 * the page header (which uses z-40); we use z-[60] here. Sets a global
 * `data-offline` attribute on <html> so other components (e.g. PageHeader)
 * can offset themselves under the banner.
 */
export function OfflineBanner() {
  const online = useOnline();

  useEffect(() => {
    if (online) {
      document.documentElement.removeAttribute("data-offline");
    } else {
      document.documentElement.setAttribute("data-offline", "");
    }
  }, [online]);

  if (online) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="sticky top-0 z-[60] bg-terracotta text-white"
    >
      <div className="mx-auto flex max-w-lg items-center justify-center gap-2 px-4 py-1.5 text-[12px] font-medium tracking-wide">
        <CloudOff className="h-3.5 w-3.5" strokeWidth={2} />
        <span>You&rsquo;re offline &mdash; showing saved data. Voice and saving are paused.</span>
      </div>
    </div>
  );
}
